import { Skeleton } from "@design-system/DataDisplay/Skeleton";
import { Box } from "@design-system/Layout/Box";
import { FlexCol, FlexRow } from "@design-system/Layout/Flex";
import { type FC } from "react";

export const ThemeProgressCardSkeleton: FC = () => {
    return (
        <FlexCol className="w-[319px]" gap="4" alignItems="start">
            <FlexCol gap="1" alignItems="start" alignSelf="stretch">
                <Skeleton className="h-[20px] w-[95px] rounded-xxl" />
            </FlexCol>
            <FlexRow
                justifyContent="center"
                alignItems="center"
                gap="10"
                alignSelf="stretch"
            >
                <Skeleton className="h-[104px] w-[104px] rounded-full grid place-content-center">
                    <Box className="h-[95px] w-[95px] rounded-full bg-white grid place-content-center">
                        <Skeleton className="w-[30px] h-[20px]" />
                    </Box>
                </Skeleton>
            </FlexRow>
            <FlexCol
                justifyContent="end"
                alignItems="start"
                alignSelf="stretch"
            >
                <FlexRow className="h-8" gap="2" w="full" pt="1">
                    <FlexCol gap="1" alignItems="start" w="full">
                        <Skeleton className="h-[15px] w-[50px]" />
                    </FlexCol>
                    <FlexCol className="w-[80px]" gap="2" alignItems="end">
                        <Skeleton className="h-[15px] w-[50px]" />
                        <Skeleton className="h-[15px] w-[50px]" />
                    </FlexCol>
                </FlexRow>

                {Array.from({ length: 4 }).map((_, idx) => (
                    <FlexRow
                        key={idx}
                        className="h-[38px]"
                        alignItems="center"
                        gap="2"
                        w="full"
                        h="8"
                        p="1"
                    >
                        <FlexCol gap="1" alignItems="start" w="full">
                            <Skeleton className="h-[20px] w-[100px] rounded-xxl" />
                        </FlexCol>
                        <FlexCol className="w-[80px]" gap="1" alignItems="end">
                            <FlexRow alignItems="center" gap="1">
                                <Skeleton className="h-2 w-[60px]" />
                                <Skeleton className="h-5 w-[34px]" />
                            </FlexRow>
                        </FlexCol>
                    </FlexRow>
                ))}
            </FlexCol>
        </FlexCol>
    );
};
